import { memo } from 'react'
import { OverlayTrigger } from 'react-bootstrap'
import { ISaleInformation } from 'types/arbitrationTypes'
import { FormFieldLabel } from '../FormFieldLabel'
import { StyledTooltip } from '../ArbitrationForm.styled'
import { StyledSaleInfoSection } from './SaleInfoSection.styled'

function stripHtmlTags(html: string): string {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent ?? div.innerText ?? ''
}

interface IProps {
  sale: ISaleInformation
}

export const SaleInfoSection = memo(function SaleInfoSection({ sale }: IProps) {
  const announcements = sale.Announcements ?? []
  const plainText = announcements.map(stripHtmlTags).join('; ')

  return (
    <StyledSaleInfoSection>
      <div className="px-3 py-2">
        <h6 className="font-weight-bold">Sale Information</h6>
      </div>
      <div className="arbitration-container">
        <FormFieldLabel label="VIN:" value={sale.VIN} />
        <FormFieldLabel label="Model Year:" value={sale.ModelYear} />
      </div>
      <div className="arbitration-container">
        <FormFieldLabel label="Model:" value={sale.Model} />
        <FormFieldLabel label="Grade:" value={sale.Grade ?? 'N/A'} />
      </div>
      <div className="arbitration-container">
        <FormFieldLabel label="Mileage:" value={sale.MileageString} />
        <FormFieldLabel label="Sale Price:" value={sale.SalePriceString} />
      </div>
      <div className="arbitration-container">
        <FormFieldLabel
          label="Sale Date:"
          value={sale.SaleDate ? new Date(sale.SaleDate).toLocaleDateString() : 'N/A'}
        />
      </div>
      {announcements.length > 0 && (
        <div className="arbitration-container">
          <div className="arbitration-field full-width">
            <span>Announcements:</span>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <StyledTooltip id="announcements-tooltip">
                  {announcements.map((announcement, index) => (
                    <div key={index} dangerouslySetInnerHTML={{ __html: announcement }} />
                  ))}
                </StyledTooltip>
              }
            >
              <div className="announcements-block">{plainText}</div>
            </OverlayTrigger>
          </div>
        </div>
      )}
      <hr />
    </StyledSaleInfoSection>
  )
})
